// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/brand-1440.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/brand-768.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/Arrow-Up-black.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/Arrow-Up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/Arrow-Down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/Arrow-Down-orange.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: #fff;
}

.navbar_custom {
  display: flex;
  width: 100%;
}
@media screen and (max-width: 768px) {
  .navbar_custom {
    background-color: #000;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
}
.navbar_brand {
  background: #000 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  padding: 48px 0px;
  width: 263px;
}
@media screen and (max-width: 768px) {
  .navbar_brand {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    padding: 38px 0px;
    width: 238px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_opened-menu {
    background-color: #18181C;
  }
  .navbar_opened-menu .navbar_brand {
    background-color: #18181C;
  }
}
.navbar_collapse {
  display: flex;
  flex-grow: 1;
  flex-basis: auto;
}
@media screen and (max-width: 768px) {
  .navbar_collapse {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .navbar_collapse.show {
    display: flex;
    flex-grow: 1;
    flex-basis: 100%;
    color: #fff;
    flex-direction: column;
    height: 100vh;
    border-top: 1px solid #FCAF17;
    padding-top: 17px;
  }
}
.navbar_links {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
@media screen and (max-width: 1140px) {
  .navbar_links {
    padding-left: 2%;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links {
    flex-direction: column;
    align-items: start;
    order: 2;
    justify-content: start;
    width: 100%;
  }
}
.navbar_links .active {
  font-weight: 700;
  color: #FCAF17;
  border-bottom: 5px solid #FCAF17;
  cursor: default;
}
.navbar_links .links {
  text-decoration: none;
  color: #000;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
  width: 18%;
  display: flex;
  height: 100%;
  align-items: center;
  transition: all 1ms;
  justify-content: center;
}
@media screen and (max-width: 1140px) {
  .navbar_links .links {
    width: auto;
    padding: 0px 10px;
    font-size: 16px;
  }
}
@media screen and (max-width: 980px) {
  .navbar_links .links {
    font-size: 14px;
  }
}
@media screen and (max-width: 910px) {
  .navbar_links .links {
    font-size: 13px;
    padding: 0px 1px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .links {
    color: #fff;
    border-bottom: 1px solid #808080;
    width: -webkit-fill-available;
    justify-content: start;
    margin: 0px 7%;
    padding: 10px 0;
    margin-bottom: 20px;
    font-size: 18px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .links:last-child {
    border: none;
  }
}
.navbar_links .links:not(.active):hover {
  background-color: #FCAF17;
}
.navbar_links .dropdown {
  height: 100%;
  width: 29%;
}
@media screen and (max-width: 1280px) {
  .navbar_links .dropdown {
    width: 32%;
  }
}
@media screen and (max-width: 1140px) {
  .navbar_links .dropdown {
    font-size: 16px;
    width: 35%;
  }
}
@media screen and (max-width: 980px) {
  .navbar_links .dropdown {
    font-size: 14px;
  }
}
@media screen and (max-width: 910px) {
  .navbar_links .dropdown {
    font-size: 13px;
    width: 38%;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown {
    height: 100%;
    width: -webkit-fill-available;
    margin: 0 7%;
  }
}
.navbar_links .dropdown-toggle {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
}
.navbar_links .dropdown-toggle:hover {
  background-color: #FCAF17;
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-toggle:hover {
    background-color: transparent;
    color: #FCAF17;
  }
}
.navbar_links .dropdown-toggle:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  border-top: none;
  margin-top: -4px;
  height: 24px;
  width: 24px;
  margin-left: 0px;
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-toggle:after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
}
@media screen and (max-width: 1140px) {
  .navbar_links .dropdown-toggle {
    font-size: 16px;
  }
}
@media screen and (max-width: 980px) {
  .navbar_links .dropdown-toggle {
    font-size: 14px;
  }
}
@media screen and (max-width: 910px) {
  .navbar_links .dropdown-toggle {
    font-size: 13px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-toggle {
    justify-content: space-between;
    font-size: 18px;
  }
}
.navbar_links .dropdown-toggle.show:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 24px;
  margin-top: 0px;
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-toggle.show:after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
}
.navbar_links .dropdown-menu {
  width: 100%;
}
.navbar_links .dropdown-menu :first-child {
  border-bottom: 1px solid #F2F2EA;
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-menu :first-child {
    border: none;
  }
}
.navbar_links .dropdown-menu.show {
  margin-top: -3px;
  padding: 12px 16px;
  border-top: none;
  border-color: #FCAF17;
  border-radius: 0px 0px 20px 20px;
}
@media screen and (max-width: 910px) {
  .navbar_links .dropdown-menu.show {
    padding: 12px 0px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-menu.show {
    width: -webkit-fill-available;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #FCAF17;
    border-radius: 0;
    padding: 12px 0px;
  }
}
.navbar_links .dropdown-item {
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  padding: 20px 0px;
  font-family: "Articulat CF";
}
.navbar_links .dropdown-item:hover {
  background-color: transparent;
  color: #FCAF17;
}
.navbar_links .dropdown-item:active {
  color: #000;
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-item:active {
    color: #fff;
  }
}
@media screen and (max-width: 910px) {
  .navbar_links .dropdown-item {
    padding: 2px 8%;
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-item {
    color: #fff;
    padding: 5px 0px;
    height: 58px;
    font-size: 18px;
  }
}
.navbar_links .dropdown-item .pdf {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  padding: 0px 16px;
  display: block;
  width: 54px;
  height: 19px;
  margin-bottom: 9px;
  color: #FCAF17;
  border-radius: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .navbar_links .dropdown-item .pdf {
    display: inline-block;
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.2);
    margin-right: 15px;
    font-size: 18px;
    line-height: 28px;
    width: 65px;
    height: 28px;
  }
}
.navbar_lang {
  width: 15%;
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
  padding-right: 5%;
  color: #808080;
  cursor: pointer;
}
@media screen and (max-width: 1140px) {
  .navbar_lang {
    padding-right: 2%;
    font-size: 16px;
  }
}
@media screen and (max-width: 980px) {
  .navbar_lang {
    font-size: 14px;
  }
}
@media screen and (max-width: 910px) {
  .navbar_lang {
    font-size: 13px;
  }
}
.navbar_lang .active {
  color: #18181C;
}
@media screen and (max-width: 768px) {
  .navbar_lang .active {
    color: #fff;
  }
}
@media screen and (max-width: 768px) {
  .navbar_lang {
    padding-right: 5%;
    order: 1;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 18px;
  }
}
.navbar_close-icon, .navbar_list-icon {
  display: none;
}
@media screen and (max-width: 768px) {
  .navbar_close-icon, .navbar_list-icon {
    width: 24px;
    height: 24px;
    margin-right: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Navbar.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AAGI;EACI,aAAA;EACA,WAAA;AAAR;AACQ;EAHJ;IAIQ,sBAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;EAEV;AACF;AAAI;EACI,yEAAA;EACA,iBAAA;EACA,YAAA;AAER;AADQ;EAJJ;IAKQ,yDAAA;IACA,iBAAA;IACA,YAAA;EAIV;AACF;AADQ;EADJ;IAEQ,yBAAA;EAIV;EAFU;IACI,yBAAA;EAId;AACF;AAAI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAER;AADQ;EAJJ;IAKQ,aAAA;EAIV;AACF;AADY;EADJ;IAEQ,aAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,sBAAA;IACA,aAAA;IACA,6BAAA;IACA,iBAAA;EAId;AACF;AADI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAGR;AAFQ;EANJ;IAOQ,gBAAA;EAKV;AACF;AAJO;EATH;IAUQ,sBAAA;IACA,kBAAA;IACA,QAAA;IACA,sBAAA;IACA,WAAA;EAOV;AACF;AANQ;EACI,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AAQZ;AANO;EACK,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAQZ;AANY;EAdL;IAeS,WAAA;IACA,iBAAA;IACA,eAAA;EASd;AACF;AARY;EAnBL;IAoBS,eAAA;EAWd;AACF;AAVY;EAtBL;IAuBS,eAAA;IACA,gBAAA;EAad;AACF;AAZY;EA1BL;IA2BS,WAAA;IACA,gCAAA;IACA,6BAAA;IACA,sBAAA;IACA,cAAA;IACA,eAAA;IACA,mBAAA;IACA,eAAA;EAed;AACF;AAbgB;EADJ;IAEQ,YAAA;EAgBlB;AACF;AAdY;EACI,yBAAA;AAgBhB;AAbQ;EACI,YAAA;EACA,UAAA;AAeZ;AAbY;EAJJ;IAKQ,UAAA;EAgBd;AACF;AAfY;EAPJ;IAQQ,eAAA;IACA,UAAA;EAkBd;AACF;AAjBY;EAXJ;IAYQ,eAAA;EAoBd;AACF;AAnBY;EAdJ;IAeQ,eAAA;IACA,UAAA;EAsBd;AACF;AArBY;EAlBJ;IAmBQ,YAAA;IACA,6BAAA;IACA,YAAA;EAwBd;AACF;AAtBY;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAwBhB;AAtBgB;EACI,yBAAA;AAwBpB;AAvBoB;EAFJ;IAGQ,6BAAA;IACA,cAAA;EA0BtB;AACF;AAxBgB;EACI,mDAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AA0BpB;AAzBoB;EAPJ;IAQQ,mDAAA;EA4BtB;AACF;AA1BgB;EA5BJ;IA6BQ,eAAA;EA6BlB;AACF;AA5BgB;EA/BJ;IAgCQ,eAAA;EA+BlB;AACF;AA9BgB;EAlCJ;IAmCQ,eAAA;EAiClB;AACF;AAhCgB;EArCJ;IAsCQ,8BAAA;IACA,eAAA;EAmClB;AACF;AAjCoB;EACI,mDAAA;EACA,WAAA;EACA,eAAA;AAmCxB;AAlCwB;EAJJ;IAKQ,mDAAA;EAqC1B;AACF;AAhCY;EACI,WAAA;AAkChB;AAjCgB;EACI,gCAAA;AAmCpB;AAlCoB;EAFJ;IAGQ,YAAA;EAqCtB;AACF;AAnCgB;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;AAqCpB;AAnCoB;EAPJ;IAQQ,iBAAA;EAsCtB;AACF;AArCoB;EAVJ;IAWQ,6BAAA;IACA,6BAAA;IACA,YAAA;IACA,gCAAA;IACA,gBAAA;IACA,iBAAA;EAwCtB;AACF;AArCY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;AAuChB;AAtCgB;EACI,6BAAA;EACA,cAAA;AAwCpB;AAtCgB;EACI,WAAA;AAwCpB;AAvCoB;EAFJ;IAGQ,WAAA;EA0CtB;AACF;AAxCgB;EAjBJ;IAkBQ,eAAA;IACA,eAAA;EA2ClB;AACF;AAzCgB;EAtBJ;IAuBQ,WAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EA4ClB;AACF;AA3CgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;AA6CpB;AA3CoB;EAdJ;IAeQ,qBAAA;IACA,4CAAA;IACA,0CAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;EA8CtB;AACF;AAzCI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA2CR;AA1CQ;EATJ;IAUQ,iBAAA;IACA,eAAA;EA6CV;AACF;AA5CQ;EAbJ;IAcQ,eAAA;EA+CV;AACF;AA9CQ;EAhBJ;IAiBQ,eAAA;EAiDV;AACF;AAhDQ;EACI,cAAA;AAkDZ;AAjDY;EAFJ;IAGQ,WAAA;EAoDd;AACF;AAlDQ;EAzBJ;IA0BQ,iBAAA;IACA,QAAA;IACA,WAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EAqDV;AACF;AAnDI;EACI,aAAA;AAqDR;AApDQ;EAFJ;IAGQ,WAAA;IACA,YAAA;IACA,kBAAA;EAuDV;AACF","sourcesContent":[".header {\n    background-color: #fff;\n}\n\n.navbar {\n    &_custom {\n        display: flex;\n        width: 100%;\n        @media  screen and (max-width: 768px) {\n            background-color: #000;\n            justify-content: space-between;\n            align-items: center;\n            flex-wrap: wrap;\n        }\n    }\n    &_brand {\n        background: #000 url(\"../../assets/images/brand-1440.png\") no-repeat center;\n        padding: 48px 0px;\n        width: 263px;\n        @media  screen and (max-width: 768px) {\n            background-image: url(\"../../assets/images/brand-768.png\") ;\n            padding: 38px 0px;\n            width: 238px;\n        }\n    }\n    &_opened-menu {\n        @media  screen and (max-width: 768px) {\n            background-color: #18181C;\n        \n            .navbar_brand {\n                background-color: #18181C;\n            }\n        }\n    \n    }\n    &_collapse {\n        display: flex;\n        flex-grow: 1;\n        flex-basis: auto;\n        @media  screen and (max-width: 768px) {\n            display: none;\n        }\n\n        &.show {\n            @media  screen and (max-width: 768px) {\n                display: flex;\n                flex-grow: 1;\n                flex-basis: 100%;\n                color: #fff;\n                flex-direction: column;\n                height: 100vh;\n                border-top: 1px solid #FCAF17;\n                padding-top: 17px;\n            }\n        }\n    }\n    &_links {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        @media  screen and (max-width: 1140px) {\n            padding-left: 2%;\n        }\n       @media  screen and (max-width: 768px) {\n            flex-direction: column;\n            align-items: start;\n            order: 2;\n            justify-content: start;\n            width: 100%;\n        }\n        .active {\n            font-weight: 700;\n            color: #FCAF17;\n            border-bottom: 5px solid #FCAF17;\n            cursor: default;\n        }\n       .links {\n            text-decoration: none;\n            color: #000;\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 27px;\n            letter-spacing: 0em;\n            width: 18%;\n            display: flex;\n            height: 100%;\n            align-items: center;\n            transition: all 1ms;\n            justify-content: center;\n    \n            @media  screen and (max-width: 1140px) {\n                width: auto;\n                padding: 0px 10px;\n                font-size: 16px;\n            }\n            @media  screen and (max-width: 980px) {\n                font-size: 14px;\n            }\n            @media  screen and (max-width: 910px) {\n                font-size: 13px;\n                padding: 0px 1px;\n            }\n            @media  screen and (max-width: 768px) {\n                color: #fff;\n                border-bottom: 1px solid #808080;\n                width: -webkit-fill-available;\n                justify-content: start;\n                margin: 0px 7%;\n                padding: 10px 0;\n                margin-bottom: 20px;\n                font-size: 18px;\n            }\n            &:last-child {\n                @media  screen and (max-width: 768px) {\n                    border: none;\n                }\n            }\n            &:not(.active):hover {\n                background-color: #FCAF17;\n            }\n        }\n        .dropdown {\n            height: 100%;\n            width: 29%;\n\n            @media  screen and (max-width: 1280px) {\n                width: 32%;\n            }\n            @media  screen and (max-width: 1140px) {\n                font-size: 16px;\n                width: 35%;\n            }\n            @media  screen and (max-width: 980px) {\n                font-size: 14px;\n            }\n            @media  screen and (max-width: 910px) {\n                font-size: 13px;\n                width: 38%;\n            }\n            @media screen and (max-width: 768px) {\n                height: 100%;\n                width: -webkit-fill-available;\n                margin: 0 7%;\n            }\n\n            &-toggle {\n                height: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 18px;\n                font-weight: 400;\n                line-height: 27px;\n                letter-spacing: 0em;\n\n                &:hover {\n                    background-color: #FCAF17;\n                    @media screen and (max-width: 768px) {\n                        background-color: transparent;\n                        color: #FCAF17;\n                    }\n                }\n                &:after  {\n                    background: url(\"../../assets/images/Arrow-Up-black.png\");\n                    border-top: none;\n                    margin-top: -4px;\n                    height: 24px;\n                    width: 24px;\n                    margin-left: 0px;\n                    @media screen and (max-width: 768px) {\n                        background: url(\"../../assets/images/Arrow-Up.png\");\n                    }\n                }\n                @media  screen and (max-width: 1140px) {\n                    font-size: 16px;\n                }\n                @media  screen and (max-width: 980px) {\n                    font-size: 14px;\n                }\n                @media  screen and (max-width: 910px) {\n                    font-size: 13px;\n                }\n                @media screen and (max-width: 768px) {\n                    justify-content: space-between;\n                    font-size: 18px;\n                }\n                &.show {\n                    &:after  {\n                        background: url(\"../../assets/images/Arrow-Down.png\");\n                        width: 24px;\n                        margin-top: 0px;\n                        @media screen and (max-width: 768px) {\n                            background: url(\"../../assets/images/Arrow-Down-orange.png\");\n                        }\n                    }\n                }\n            }\n  \n            &-menu {\n                width: 100%;\n                :first-child {\n                    border-bottom: 1px solid #F2F2EA;\n                    @media screen and (max-width: 768px) {\n                        border: none;\n                    }\n                }\n                &.show {\n                    margin-top: -3px;\n                    padding: 12px 16px;\n                    border-top: none;\n                    border-color: #FCAF17;\n                    border-radius: 0px 0px 20px 20px;\n\n                    @media screen and (max-width: 910px) {\n                        padding: 12px 0px;\n                    }\n                    @media screen and (max-width: 768px) {\n                        width: -webkit-fill-available;\n                        background-color: transparent;\n                        border: none;\n                        border-bottom: 1px solid #FCAF17;\n                        border-radius: 0;\n                        padding: 12px 0px;\n                    }\n                }\n            }\n            &-item {\n                font-size: 18px;\n                font-weight: 400;\n                line-height: 20px;\n                letter-spacing: 0em;\n                padding: 20px 0px;\n                font-family: 'Articulat CF';\n                &:hover {\n                    background-color: transparent;\n                    color: #FCAF17;\n                }\n                &:active {\n                    color: #000;\n                    @media screen and (max-width: 768px) {\n                        color: #fff;\n                    }\n                }\n                @media screen and (max-width: 910px) {\n                    padding: 2px 8%;\n                    font-size: 14px;\n                }\n\n                @media screen and (max-width: 768px) {\n                    color: #fff;\n                    padding: 5px 0px;\n                    height: 58px;\n                    font-size: 18px;\n                }\n                .pdf {\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 19px;\n                    letter-spacing: 0em;\n                    padding: 0px 16px;\n                    display: block;\n                    width: 54px;\n                    height: 19px;\n                    margin-bottom: 9px;\n                    color: #FCAF17;\n                    border-radius: 40px;\n                    border: 1px solid rgba(0, 0, 0, 0.2);\n\n                    @media screen and (max-width: 768px) {\n                        display: inline-block;\n                        border: 0.5px solid #FFFFFF33;\n                        background-color: #FFFFFF33;\n                        margin-right: 15px;\n                        font-size: 18px;\n                        line-height: 28px;\n                        width: 65px;\n                        height: 28px;\n                    }\n                }\n            }\n        }\n    }\n    &_lang {\n        width: 15%;\n        display: flex;\n        align-items: center;\n        gap: 15px;\n        justify-content: flex-end;\n        padding-right: 5%;\n        color: #808080;\n        cursor: pointer;\n        @media  screen and (max-width: 1140px) {\n            padding-right: 2%;\n            font-size: 16px;\n        }\n        @media  screen and (max-width: 980px) {\n            font-size: 14px;\n        }\n        @media  screen and (max-width: 910px) {\n            font-size: 13px;\n        }\n        .active {\n            color: #18181C;\n            @media screen and (max-width: 768px) {\n                color: #fff;\n            }\n        }\n        @media screen and (max-width: 768px) {\n            padding-right: 5%;\n            order: 1;\n            width: 100%;\n            justify-content: center;\n            margin-bottom: 20px;\n            font-size: 18px;\n        }\n    }\n    &_close-icon, &_list-icon   {\n        display: none;\n        @media screen and (max-width: 768px) {\n            width: 24px;\n            height: 24px;\n            margin-right: 30px;\n        }\n    }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
